<div id="cmsSection" [ngClass]="{'hide':(isFailedState$ | async) === true}">
  <div id="divCmsContent">
    <webview id="contentWebview" style="width:1024px; height:712px" plugins (dom-ready)="pageLoaded()">
    </webview>
  </div>
  @if (hasLoaded$|async) {
    <div id="cmsContentHasLoaded" hidden></div>
  }
</div>
@if ((isFailedState$ | async) === true) {
  <div class="nim__content">
    <div id="failedStation" nc-failed-window></div>
  </div>
}